import { call, getContext, put, takeEvery } from "redux-saga/effects";

import { getUserBlockListActionTypes } from "./actionTypes";
import { CONTEXT } from "@const/redux";
import { getUserBlockListFailure, getUserBlockListSuccess } from "./actions";
import { normalizeBlockListArray } from "@helpers/blocklist";

const getUserBlockListAsync = ({ UsersService, params }) => {
  if (!UsersService) {
    console.log("Required services does not exist");

    return null;
  }

  return UsersService.getUserBlocklist(params);
};

function* getUserBlockList({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { data, pagination } = yield call(getUserBlockListAsync, {
      UsersService,
      params: payload,
    });

    const { result: allList, entities } = normalizeBlockListArray(data);

    const { blocklist: listById } = entities;
    const { totalCount } = pagination;

    yield put(getUserBlockListSuccess({ allList, listById, totalCount }));
  } catch ({ error }) {
    yield put(getUserBlockListFailure({ error }));
  }
}

export function* watchGetUserBlockList() {
  yield takeEvery(getUserBlockListActionTypes.request, getUserBlockList);
}
